<template>
  <div id="app"
    class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
    <HeadNav selectedLanguage="en" page="gb" :gotodownload="gotodownload" :apk="apk" />

    <div id="page" class="site container hfeed">
      <div id="content" class="site-content">
        <div id="primary" class="content-area">
          <main id="maincontent" class="site-main">
            <section class="hero">
              <div class="hero__content">
                <div class="hero__panel">
                  <div class="hero__header">
                    <h1 class="hero__title">
                      Instagram Video Download
                    </h1>
                    <p class="hero__subtitle">
                      Download Video Instagram, Photo,Reels, Stories Online
                    </p>
                    <p class="hero__hint">
                      PASTE LINK AND CLICK DOWNLOAD BUTTON
                    </p>
                  </div>
                  <form class="hero__form" @submit.prevent="handleInstagramDownload">
                    <input v-model="pasteUrl" class="hero__input" type="text"
                      placeholder="PASTE URL" aria-label="Paste Instagram link">
                    <button class="hero__button" type="submit" :disabled="isParsing">
                      <!-- <span class="hero__button-icon"></span> -->
                      <img style="width: 24px; height: 24px;" src="../assets/Download.png"
                        alt="Download"></img>
                      {{ isParsing ? 'Parsing...' : 'Download' }}
                    </button>
                  </form>
                  <p v-if="parseError" class="hero__error">{{ parseError }}</p>
                  <div v-if="parseResult && parseResult.media && parseResult.media.length" class="ig-result">
                    <div class="ig-result__header">
                      <strong>{{ parseResult.mediaCount }} file{{ parseResult.mediaCount > 1 ? 's' : '' }} ready</strong>
                      <span v-if="parseResult.username">@{{ parseResult.username }}</span>
                    </div>
                    <div class="ig-result__list">
                      <div v-for="(item, index) in parseResult.media" :key="item.url" class="ig-result__item">
                        <video v-if="item.type === 'video'" class="ig-result__media" :src="item.url"
                          :poster="item.thumbnail" controls playsinline preload="metadata"></video>
                        <img v-else class="ig-result__media" :src="item.url" alt="Instagram media">
                        <div class="ig-result__body">
                          <span>{{ getMediaTypeLabel(item.type) }} {{ index + 1 }}</span>
                          <a class="ig-result__download" :href="getDownloadUrl(item.url, item.type)">Download</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div class="markdown-content">
              <h2>Use <strong>SnapInsta</strong> to Download Videos and Photos from Instagram</h2>

              <p>
                SnapInsta is dedicated to helping users easily save their important Instagram
                content. With our efficient platform, you can quickly download Instagram Reels,
                videos, Stories, and photos simply by pasting a link. Whether you're a content
                creator or a regular user, SnapInsta has you covered for your download needs.
              </p>

              <h2>Why People Choose SnapInsta?</h2>

              <ul>
                <li>
                  <strong>Simple and Easy to Use:</strong> A clear page and simple guide to help
                  beginners to use it.
                </li>
                <li>
                  <strong>All Ins Content:</strong> This sitesupports downloading various content
                  types, including Reels, Stories, videos, and images.
                </li>
                <li>
                  <strong>Fast and Secure:</strong> Fast video download speeds to protecting user
                  data security.
                </li>
                <li>
                  <strong>Smooth Experience:</strong> Enjoy a stable and smooth user experience
                  without complicated steps.
                </li>
              </ul>

              <p>
                <a href="https://snapsinsta.com/">SnapInsta</a> app is a user-friendly app designed
                for Instagram users to download media content from the platform. Whether you're a
                casual user or a content creator, you can easily save your favorite content with
                SnapInsta.
              </p>

              <div style="position: relative;">
                <img src="../assets/snapinsta.webp" alt="SnapInsta">
                <button class="hero__button"
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);z-index: 1000;"
                  @click="gotodownload">
                  Download
                </button>
                </img>
              </div>

              <h2>Key Features of SnapInsta Downloader</h2>

              <h3><strong>Reel Downloader:</strong></h3>

              <p>
                With the rise of short-form video content on Instagram, reels have become popular.
                SnapsInsta allows you to download your favorite reels directly to your device,
                enabling you to enjoy them offline or share them with friends.
              </p>

              <h3><strong>Video Downloader:</strong></h3>

              <p>
                Whether it's a tutorial, a funny clip, or a mesmerizing travel video, SnapsInsta
                helps you to download any video from Instagram easily. Simply copy the link of the
                video you wish to download and paste it into SnapsInsta's interface - the rest is
                taken care of for you.
              </p>

              <h3><strong>Story and Photo Downloader:</strong></h3>

              <p>
                Instagram stories and photos often capture special moments that we want to cherish
                forever. With SnapsInsta, you can save these moments by downloading stories and
                photos effortlessly. Whether it's a stunning landscape, a delicious meal, or a
                heartwarming selfie, you can save memories with ease.
              </p>

              <h3><strong>User-Friendly Interface:</strong></h3>

              <p>
                SnapsInsta features a clean interface that makes downloading Instagram content a
                breeze. Whether you're a tech-savvy user or a novice, you'll find the website easy
                to navigate, ensuring a seamless downloading experience every time.
              </p>

              <h3><strong>Fast and Secure:</strong></h3>

              <p>
                SnapsInsta prioritizes speed and security, ensuring that your downloads are
                processed quickly and securely. You can rest assured that your data remains private
                and protected throughout the downloading process.
              </p>

              <h2><strong>How to Use SnapInsta to Download Instagram Videos:</strong></h2>

              <p>
                Many prople choose SnapInsta which is an online platform to save Ins content. Below
                are the steps:
              </p>

              <ol>
                <li>
                  <strong>Copy the Link:</strong> Navigate to the Instagram reel, video, story, or
                  photo you wish to download and copy its link.
                </li>
                <li>
                  <strong>Paste the Link:</strong> Visit <a
                    href="https://snapsinsta.com/">snapsinsta.com</a> and paste the copied link into
                  the designated field.
                </li>
                <li>
                  <strong>Download:</strong> Click on the download button, and SnapsInsta will
                  process the link, allowing you to download the desired content to your device.
                </li>
                <li>
                  <strong>Enjoy:</strong> Once the download is complete, you can enjoy the
                  downloaded content offline or share it with friends and family.
                </li>
              </ol>

              <h2>FAQ about Instagram Downloader</h2>

              <h3>How to Download instagram Video High Quality from Link?</h3>

              <p>
                Our tool allows you to download Instagram videos by simply copying and pasting the
                video's URL into the
                provided field on our website. Click the download button, and the video will be
                saved to your device for
                offline viewing.
              </p>

              <h3>Can I download private Instagram videos?</h3>

              <p>
                No, our tool only supports downloading videos from public Instagram accounts.
                Private videos are
                restricted to the account owners and their approved followers.
              </p>

              <h3>Do I need to create an account to use the Instagram Video Downloader Tool?</h3>

              <p>
                No, you can use our tool without creating an account. We do not require any personal
                information from
                you.
              </p>

              <h3>Is the Instagram Video Downloader Tool free to use?</h3>

              <p>
                Yes, our tool is completely free to use. You can download Instagram videos without
                any charges or
                subscription fees.
              </p>

              <h3>Does the Instagram Video Downloader Tool work on all devices?</h3>

              <p>
                Yes, our website is accessible from various devices, including desktop computers,
                laptops, smartphones,
                and tablets. You can use our tool on any device with an internet connection and a
                web browser.
              </p>

              <h3>How do you ensure the privacy and security of user data?</h3>

              <p>
                We prioritize user privacy and do not collect any personal information during the
                video download
                process. We also take measures to protect the security of our website and regularly
                update our security
                protocols.
              </p>

              <h3>Can I download multiple videos at once?</h3>

              <p>
                Our tool is designed to download one video at a time. If you wish to download
                multiple videos, you can
                do so consecutively by repeating the process for each video.
              </p>

              <h3>Are there any restrictions on the usage of downloaded videos?</h3>

              <p>
                Once you download a video, you are responsible for its usage. Ensure that you comply
                with copyright
                laws and the terms of use set by the video's owner. We assume no liability for the
                misuse or
                unauthorized use of downloaded videos.
              </p>

              <h3>Is it legal to download Instagram videos?</h3>

              <p>
                Downloading Instagram videos for personal use is generally allowed as long as you
                have the necessary
                permissions and rights for the content. However, it's essential to respect copyright
                laws and the terms
                of use of the videos you download.
              </p>

              <h3>How often is the Instagram Video Downloader Tool updated?</h3>

              <p>
                We strive to keep our tool up-to-date and functional with the latest changes and
                updates to Instagram.
                However, please note that occasional adjustments may be required due to Instagram's
                platform changes.
              </p>
              <p>
                For added privacy and security while browsing online, consider using
                <a href="https://www.supervpn.click/" target="_blank" rel="noopener noreferrer">Secure Free VPN</a>
                to help keep your internet connection protected.
              </p>
            </div>
          </main>
        </div>
      </div>
    </div>

    <!-- <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
    GB WhatsApp Download(v18.70)
  </div> -->
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import 'swiper/css/swiper.css';
import axios from 'axios';

export default {
  name: 'Home',
  components: {
    HeadNav,
  },
  data () {
    return {
      pageName: 'home',
      tableHide: true,
      comment: {
        name: '',
        email: '',
        content: '',
      },
      pasteUrl: '',
      isParsing: false,
      parseResult: null,
      parseError: '',
      showapk: false,
      showTableOfContents: false,

      apk: 'https://apk.instasaves.io/app/android/apk/Instagram_367.0.0.44.74.apk',
      from: 'gb',
      filename: 'gb',
      clickNum: 0,
      selectedLanguage: 'en',
    };
  },
  computed: {
    downloadURL () {
      // var params = window.location.search;
      // return `/gbwhatsapp-apk-download${params}`;
      if (typeof window === 'undefined') {
        // Server-side rendering logic
        return '/gbwhatsapp-apk-download'; // Adjust this based on your server-side logic
      } else {
        // Client-side rendering logic
        let params = window.location.search;
        return `/gbwhatsapp-apk-download${params}`;
      }
    },
  },
  mounted () {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    // if (this.$global.GetQueryString('from')) {
    //   this.getAPK();
    // } else {
    //   this.getOfficalApk();
    // }

    // window.adsTag.renderInterstitial(54982);
  },
  methods: {
    downloadClick () {
      this.$router.push({
        name: 'en-download'
      });
    },
    getAPK () {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk (type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload () {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }

    },
    getMediaTypeLabel (type) {
      return type === 'video' ? 'Video' : 'Image';
    },
    getDownloadUrl (url, type) {
      return `/api/instagram/download?url=${encodeURIComponent(url)}&type=${encodeURIComponent(type)}`;
    },
    async handleInstagramDownload () {
      const url = (this.pasteUrl || '').trim();
      if (!url) {
        this.parseError = 'Please paste an Instagram link first.';
        return;
      }
      if (!url.includes('instagram.com')) {
        this.parseError = 'Please enter a valid Instagram URL.';
        return;
      }

      this.isParsing = true;
      this.parseError = '';
      this.parseResult = null;

      try {
        const res = await axios.post('/api/instagram/parse', { url }, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        this.parseResult = res.data;
      } catch (error) {
        this.parseError =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'Failed to parse Instagram content. Please check the URL and try again.';
      } finally {
        this.isParsing = false;
      }
    },
    gotoblog () {
      window.location.href = '/blogs';
    },
    jump (url) {
      window.location.href = url;
    },

  },
};
</script>

<style lang="scss">
h2,
h3 {
	color: #186dff !important;
	strong {
		color: #186dff !important;
	}
}

.markdown-content {
	padding: 48px 40px;
	line-height: 1.75;
	margin: 0 auto;
	max-width: 1000px;
	background: #ffffff;
	border-radius: 12px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
	color: #4a5568;
	font-size: 16px;
}

.markdown-content h1 {
	font-size: 2.25em;
	margin: 0 0 24px 0;
	padding-bottom: 16px;
	border-bottom: 2px solid #e2e8f0;
	color: #1a202c;
	font-weight: 700;
	line-height: 1.3;
}

.markdown-content h2 {
	font-size: 1.75em;
	margin: 48px 0 20px 0;
	padding-bottom: 12px;
	border-bottom: 1px solid #e2e8f0;
	font-weight: 600;
	line-height: 1.4;
}

.markdown-content h3 {
	font-size: 1.375em;
	margin: 36px 0 16px 0;
	color: #2d3748;
	font-weight: 600;
	line-height: 1.4;
}

.markdown-content h4 {
	font-size: 1.125em;
	margin: 28px 0 12px 0;
	color: #2d3748;
	font-weight: 600;
}

.markdown-content p {
	margin: 0 0 20px 0;
	color: #4a5568;
	line-height: 1.75;
}

.markdown-content ul,
.markdown-content ol {
	margin: 20px 0;
	padding-left: 28px;
	color: #4a5568;
}

.markdown-content li {
	margin: 10px 0;
	line-height: 1.75;
}

.markdown-content li strong {
	color: #2d3748;
	font-weight: 600;
}

.markdown-content blockquote {
	border-left: 3px solid #cbd5e0;
	padding: 16px 20px;
	margin: 24px 0;
	background: #f7fafc;
	color: #4a5568;
	border-radius: 0 6px 6px 0;
	font-style: italic;
}

.markdown-content hr {
	margin: 40px 0;
	border: none;
	border-top: 1px solid #e2e8f0;
	height: 0;
}

.markdown-content pre {
	background: #f7fafc;
	padding: 16px;
	border-radius: 6px;
	overflow-x: auto;
	border: 1px solid #e2e8f0;
	margin: 20px 0;
}

.markdown-content code {
	font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
	font-size: 0.9em;
	background: #f7fafc;
	padding: 3px 8px;
	border-radius: 4px;
	color: #e53e3e;
	border: 1px solid #e2e8f0;
}

.markdown-content pre code {
	background: transparent;
	padding: 0;
	border: none;
	color: #2d3748;
}

.markdown-content img {
	width: 100%;
	height: auto;
	border-radius: 8px;
	margin: 32px 0;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.markdown-content img:hover {
	transform: translateY(-2px);
	box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.markdown-content > div {
	margin: 32px 0;
}

.markdown-content a {
	color: #3182ce;
	text-decoration: none;
	transition: color 0.2s ease;
	font-weight: 500;
}

.markdown-content a:hover {
	color: #2c5aa0;
	text-decoration: underline;
}

.markdown-content strong {
	font-weight: 600;
	color: #2d3748;
}

.markdown-content em {
	font-style: italic;
	color: #4a5568;
}

.markdown-content table {
	width: 100%;
	border-collapse: collapse;
	margin: 32px 0;
	font-size: 0.95em;
	border: 1px solid #e2e8f0;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.markdown-content th,
.markdown-content td {
	padding: 14px 18px;
	text-align: left;
	border-bottom: 1px solid #e2e8f0;
}

.markdown-content th {
	background-color: #f7fafc;
	font-weight: 600;
	color: #2d3748;
	text-transform: uppercase;
	font-size: 0.875em;
	letter-spacing: 0.5px;
}

.markdown-content tr:last-child td {
	border-bottom: none;
}

.markdown-content tr:nth-child(even) {
	background-color: #fafbfc;
}

.markdown-content tr:hover {
	background-color: #f7fafc;
	transition: background-color 0.2s ease;
}

@media (max-width: 768px) {
	.markdown-content {
		padding: 32px 24px;
		font-size: 15px;
		border-radius: 8px;
	}

	.markdown-content h1 {
		font-size: 1.875em;
		margin-bottom: 20px;
	}

	.markdown-content h2 {
		font-size: 1.5em;
		margin-top: 36px;
	}

	.markdown-content h3 {
		font-size: 1.25em;
		margin-top: 28px;
	}

	.markdown-content ul,
	.markdown-content ol {
		padding-left: 24px;
	}
}

.hero {
	width: 100%;
	min-height: 80vh;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 80px 16px 120px;
	background: linear-gradient(135deg, #2e2bf3 0%, #ff38c9 100%);
}

.hero__content {
	width: 100%;
	max-width: 1100px;
	display: flex;
	justify-content: center;
}

.hero__panel {
	width: 100%;
	max-width: 950px;
	padding: 32px 40px 44px;
	border-radius: 14px;
	background: linear-gradient(135deg, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.4) 100%);
	text-align: center;
}

.hero__header {
	margin-bottom: 26px;
}

.hero__title {
	margin: 0;
	font-size: 28px;
	font-weight: 700;
	color: #fff;
}

.hero__subtitle {
	margin: 12px 0 8px;
	font-size: 16px;
	font-weight: 600;
	color: #fff;
}

.hero__hint {
	margin: 0;
	font-size: 12px;
	letter-spacing: 0.5px;
	color: #fff;
	text-transform: uppercase;
}

.hero__form {
	display: flex;
	flex-direction: column;
	gap: 16px;
	align-items: center;
}

.hero__input {
	width: 100%;
	max-width: 880px;
	height: 48px;
	padding: 0 16px;
	border: 1px solid #d8d8d8;
	border-radius: 4px;
	background-color: #ffffff;
	box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
	font-size: 14px;
	color: #333;
}

.hero__input::placeholder {
	color: #777;
}

.hero__button {
	/* background: url('../assets/snapinsta.webp'); */
	background-size: cover;
	/* Fit the background image to the button. */
	background-repeat: no-repeat;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 0 36px;
	height: 52px;
	width: 240px;
	border: none;
	border-radius: 26px;
	cursor: pointer;
	font-size: 16px;
	font-weight: 600;
	color: #fff;
	background: linear-gradient(135deg, #0088ff 0%, #0067e0 100%);
	box-shadow: 0 12px 28px rgba(232, 236, 241, 0.35);
	transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.hero__button:hover {
	transform: translateY(-1px);
	box-shadow: 0 16px 30px rgba(190, 213, 240, 0.4);
}

.hero__button:active {
	transform: translateY(0);
	box-shadow: 0 10px 20px rgba(190, 217, 248, 0.32);
}

.hero__button:disabled {
	cursor: not-allowed;
	opacity: 0.72;
	transform: none;
}

.hero__error {
	margin: 18px auto 0;
	max-width: 880px;
	padding: 10px 14px;
	border-radius: 6px;
	background: rgba(255, 255, 255, 0.9);
	color: #d92662;
	font-size: 14px;
	font-weight: 600;
}

.ig-result {
	margin: 22px auto 0;
	max-width: 880px;
	text-align: left;
}

.ig-result__header {
	display: flex;
	justify-content: space-between;
	gap: 12px;
	margin-bottom: 12px;
	color: #fff;
	font-size: 14px;
}

.ig-result__list {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	gap: 14px;
}

.ig-result__item {
	overflow: hidden;
	border-radius: 8px;
	background: #fff;
	box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14);
}

.ig-result__media {
	display: block;
	width: 100%;
	aspect-ratio: 1 / 1;
	object-fit: cover;
	background: #101010;
}

.ig-result__body {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 12px;
	color: #333;
	font-size: 14px;
	font-weight: 600;
}

.ig-result__download {
	flex: 0 0 auto;
	padding: 8px 14px;
	border-radius: 999px;
	background: #0067e0;
	color: #fff;
	text-decoration: none;
	font-size: 13px;
}

.ig-result__download:hover {
	background: #0058c2;
	color: #fff;
	text-decoration: none;
}

.hero__button-icon {
	width: 0;
	height: 0;
	border-top: 6px solid transparent;
	border-bottom: 6px solid transparent;
	border-left: 10px solid #fff;
}

@media (max-width: 768px) {
	.hero {
		padding: 60px 16px 80px;
	}

	.hero__panel {
		padding: 28px 24px 38px;
	}

	.hero__title {
		font-size: 24px;
	}

	.hero__subtitle {
		font-size: 15px;
	}

	.ig-result__header,
	.ig-result__body {
		align-items: flex-start;
		flex-direction: column;
	}

	.ig-result__download {
		width: 100%;
		text-align: center;
	}
}
</style>
